import React from "react";
import { ICON_TYPES } from "../../utils/constants";

const SimpleNotification = ({
    message,
    type = "",
    className = "",
    textClassName = "",
}) => {
    return (
        <div
            className={`flex gap-1 notification-alert py-2 px-4 rounded mb-4 ${className}`}
        >
            <i
                className={`fas fa-${
                    type ? ICON_TYPES[type] : ""
                } text-xs text-primary-blue`}
            />
            <p className={`text-xs ${textClassName}`}>{message}</p>
        </div>
    );
};

export default SimpleNotification;
